import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { SectionHeaderLabel } from 'src/domains/layouts/shared/cms/form/Form.style';

export const HeroWidgetImageUpload = observer(() => {
    const { heroWidgetState } = useAppStateContext();

    return (
        <div>
            <SectionHeaderLabel>Select Header Background Image</SectionHeaderLabel>

            <UploadImg
                title='Mobile Image (Header)'
                uploadImageState={heroWidgetState.uploadHeaderImgSmall}
            />
            <UploadImg
                title='Tablet Image (Header)'
                uploadImageState={heroWidgetState.uploadHeaderImgMedium}
            />
            <UploadImg
                title='Desktop Image (Header)'
                uploadImageState={heroWidgetState.uploadHeaderImgBig}
            />

            <SectionHeaderLabel>Select Promo Image</SectionHeaderLabel>

            <UploadImg
                title='Mobile Image (Promotion)'
                uploadImageState={heroWidgetState.uploadPromoImgSmall}
            />
            <UploadImg
                title='Tablet Image (Promotion)'
                uploadImageState={heroWidgetState.uploadPromoImgMedium}
            />
            <UploadImg
                title='Desktop Image (Promotion)'
                uploadImageState={heroWidgetState.uploadPromoImgBig}
            />
        </div>
    );
});
